import { Link } from "react-router-dom";

const collections = [
  {
    title: "雨夜与霓虹",
    subtitle: "城市夜色的另一面",
    description: "湿漉漉的街道、亮着的招牌，和总也走不到头的那条巷子。适合想跟着镜头一起淋一场雨的夜晚。",
    tags: ["悬疑", "犯罪"],
    to: "/movies",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20moody%20city%20street%20at%20midnight%20in%20heavy%20rain%2C%20glowing%20amber%20signs%20reflected%20on%20wet%20asphalt%2C%20deep%20navy%20shadows%20and%20soft%20mist%2C%20an%20empty%20alley%20with%20distant%20warm%20light%2C%20quiet%20cinematic%20atmosphere%2C%20high%20detail%2C%20no%20text%20and%20no%20lettering&width=900&height=640&seq=mood-collection-01&orientation=landscape",
  },
  {
    title: "深海与星空",
    subtitle: "把音量调到最小",
    description: "缓慢的镜头、很远的回声。科幻与孤独感并行，适合一个人戴耳机、把房间灯关掉的时候。",
    tags: ["科幻", "剧情"],
    to: "/movies",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20frame%20of%20a%20dark%20ocean%20surface%20under%20a%20deep%20starry%20night%20sky%2C%20faint%20pale%20blue%20horizon%20glow%20and%20subtle%20mist%2C%20distant%20isolated%20light%2C%20deep%20navy%20tones%20with%20silver%20highlights%2C%20calm%20lonely%20atmosphere%2C%20high%20detail%2C%20no%20text%20and%20no%20lettering&width=900&height=640&seq=mood-collection-02&orientation=landscape",
  },
  {
    title: "一个人的深夜厨房",
    subtitle: "三分钟的治愈片段",
    description: "水开的声音、切菜的节奏、终于坐下来的那一声叹气。生活类短视频合集，适合配着夜宵一起看。",
    tags: ["生活", "剧情"],
    to: "/short-videos",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20cozy%20night%20kitchen%20counter%20with%20warm%20amber%20lamp%20glow%2C%20a%20steaming%20pot%20and%20chopped%20vegetables%20on%20a%20wooden%20board%2C%20deep%20navy%20shadows%20around%2C%20window%20reflecting%20city%20lights%2C%20intimate%20quiet%20atmosphere%2C%20high%20detail%2C%20no%20text%20and%20no%20lettering&width=900&height=640&seq=mood-collection-03&orientation=landscape",
  },
];

export default function MoodCollections() {
  return (
    <section className="w-full px-4 pt-14 md:px-8 md:pt-20">
      <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between md:mb-8">
        <div>
          <p className="mb-2 flex items-center gap-2 font-label text-xs tracking-[0.3em] text-accent-500">
            <span className="inline-block h-px w-6 bg-accent-500/70" />
            MOOD COLLECTIONS
          </p>
          <h2 className="font-heading text-xl font-bold tracking-wide text-foreground-50 md:text-2xl">
            按今晚的气氛选片
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-6 text-foreground-400">
            不确定看什么的时候，先从此刻的心情开始。三种不同气氛的主题合集，点进去就是对应的片单。
          </p>
        </div>
        <Link
          to="/movies"
          className="group inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-700 px-3.5 py-2 text-xs text-foreground-300 transition-colors hover:border-accent-500/60 hover:text-accent-400"
        >
          查看全部主题
          <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
        {collections.map((item, index) => (
          <Link
            key={item.title}
            to={item.to}
            className="group relative block h-[220px] overflow-hidden rounded-lg border border-background-800 md:h-[260px]"
          >
            <img
              src={item.image}
              alt={`${item.title}主题合集封面`}
              title={`${item.title} - 午夜视频主题片单`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/55 to-background-950/10" />
            <div className="absolute inset-x-0 bottom-0 p-5">
              <div className="flex flex-wrap items-center gap-1.5">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-background-950/60 px-2 py-0.5 text-[10px] text-secondary-200 backdrop-blur-sm"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <h3 className="mt-2 font-heading text-lg font-semibold text-foreground-50 transition-colors group-hover:text-accent-400">
                {item.title}
              </h3>
              <p className="mt-0.5 text-xs text-accent-400/90">{item.subtitle}</p>
              <p className="mt-2 line-clamp-2-safe text-xs leading-6 text-foreground-400">
                {item.description}
              </p>
              <span className="mt-3 inline-flex items-center gap-1.5 text-xs text-foreground-200">
                进入合集
                <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-1" />
              </span>
            </div>
            <span className="absolute right-4 top-4 font-label text-xs tracking-[0.2em] text-foreground-400">
              0{index + 1}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}